import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'icon',
    label: i18n('entities.formCategory.fields.icon'),
    schema: schemas.images(
      i18n('entities.formCategory.fields.icon'),
      {
        "max": 1
      },
    ),
  },
  {
    name: 'name',
    label: i18n('entities.formCategory.fields.name'),
    schema: schemas.string(
      i18n('entities.formCategory.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'abbreviation',
    label: i18n('entities.formCategory.fields.abbreviation'),
    schema: schemas.string(
      i18n('entities.formCategory.fields.abbreviation'),
      {},
    ),
  },
  {
    name: 'description',
    label: i18n('entities.formCategory.fields.description'),
    schema: schemas.string(
      i18n('entities.formCategory.fields.description'),
      {},
    ),
  },
  {
    name: 'parentCategory',
    label: i18n('entities.formCategory.fields.parentCategory'),
    schema: schemas.relationToOne(
      i18n('entities.formCategory.fields.parentCategory'),
      {},
    ),
  },
  {
    name: 'tenantAccess',
    label: i18n('entities.formCategory.fields.tenantAccess'),
    schema: schemas.string(
      i18n('entities.formCategory.fields.tenantAccess'),
      {},
    ),
  },
];